
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';
import Modal from 'react-modal';
import { TablaDeCarritoEnModal } from './components';
import { useAuthStore, useGlobalValueStore, useModalStore } from '../../stores';
import { useListCarritoXUser } from '../../hooks/cache';
import { separadorMillares, usePrecioCarritoXRole } from '../../hooks';
import { roleCompra } from '../../data';
Modal.setAppElement('#root');




export const ModalCarrito = () => {


    const navigate = useNavigate();
    const { view } = useGlobalValueStore();
    const { usuario } = useAuthStore();
    const { data } = useListCarritoXUser(usuario.id);
    const { precioTotalSegunRol } = usePrecioCarritoXRole();
    const { modalLateral, modalToggleLateral } = useModalStore();


    const handlerComprar = () => {
        navigate('/super/comprar-ahora');
        modalToggleLateral(false);
    }


    return (
        
        <Modal isOpen={modalLateral} onRequestClose={() => modalToggleLateral(false)} 
            className="modal-custom" closeTimeoutMS={200} overlayClassName="modal-fondo"
        >
            <Typography sx={{fontSize:21, fontWeight:'bold', textAlign:'center', my:2}}>
                Productos del Carrito
            </Typography>

            <TablaDeCarritoEnModal data={data || []} />

            <div className='fin-carrito'>
                {data?.length > 0 &&
                <Grid container sx={{display:'flex', justifyContent:'center'}}>
                    <Typography variant="h3">
                        { `Total ${roleCompra[view]}: $${ separadorMillares(precioTotalSegunRol(data)) }` }
                    </Typography>
                </Grid>
                }

                <Grid container direction="column" sx={{ alignItems:'center', mt:1, mb:3}}>
                    {data?.length > 0 && 
                    <Grid item>
                        <Button variant="outlined" color="secondary" onClick={handlerComprar} fullWidth sx={{minWidth:'200px'}}>
                            Verificar
                        </Button>
                    </Grid>
                    }
                    <Grid item>
                        <Button variant="outlined" color="primary" onClick={() => modalToggleLateral(false)} fullWidth sx={{minWidth:'200px'}}>
                            Salir
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </Modal>
    )
}
